import Backgrounds from './Backgrounds';
import Images from './Images';
import { useNextScreensAttributes } from './useNextScreensAttributes';

type ImagesPreloaderProps = {
  nextScreenId: string;
};

const ImagesPreloader = ({ nextScreenId }: ImagesPreloaderProps) => {
  const attributes = useNextScreensAttributes(nextScreenId);

  return (
    <>
      <Images attributes={attributes} />
      <Backgrounds attributes={attributes} />
    </>
  );
};

export default ImagesPreloader;
